var render = function render(){var _vm=this,_c=_vm._self._c;return _c('TheTopbarModalLayout',{staticClass:"diy-topbar__alerts",scopedSlots:_vm._u([{key:"header",fn:function(){return [_c('span',{staticClass:"diy-topbar__alerts-title"},[_vm._v("\n      "+_vm._s(_vm.$t('ui.generals.notifications_title'))+"\n    ")])]},proxy:true},{key:"content",fn:function(){return [_c('Alerts')]},proxy:true}])})
}
var staticRenderFns = []

export { render, staticRenderFns }